module.exports = __webpack_public_path__ + "img/icon-warning.effb3f2b.png";